import { ComponentType } from 'react';
import {
  RouteProps as ReactDOMRouteProps,
  Route as ReactDOMRoute,
  Redirect,
  RouteComponentProps
} from 'react-router-dom';

import { useAuth } from '~context/auth';

interface RouteProps extends Omit<ReactDOMRouteProps, 'component' | 'render'> {
  isPrivate?: boolean;
  component?: ComponentType<RouteComponentProps>;
  render?: () => JSX.Element;
}

export function Route({
  isPrivate = true,
  component: Component,
  render,
  ...rest
}: RouteProps) {
  const { signed } = useAuth();

  if (isPrivate && !signed) {
    return <Redirect to="/" />
  }

  if (!isPrivate && signed) {
    return <Redirect to="/admin-dashboard" />
  }

  // Support both component and render props
  if (render) {
    return (
      <ReactDOMRoute
        {...rest}
        render={render}
      />
    );
  }

  if (Component) {
    return (
      <ReactDOMRoute
        {...rest}
        render={(props) => <Component {...props} />}
      />
    );
  }

  return null;
}
